'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var rulesets = {
    all: {
        value: 'all',
        name: 'All',
        tags: [],
        type: 'ALL'
    },
    wcag22aaa: {
        value: 'wcag22aaa',
        name: 'WCAG 2.2 AAA',
        tags: [
            'wcag22aaa',
            'wcag22aa',
            'wcag22a',
            'wcag21aaa',
            'wcag21aa',
            'wcag21a',
            'wcag2aaa',
            'wcag2aa',
            'wcag2a'
        ],
        type: 'WCAG'
    },
    wcag22aa: {
        value: 'wcag22aa',
        name: 'WCAG 2.2 AA',
        tags: ['wcag22aa', 'wcag22a', 'wcag21aa', 'wcag21a', 'wcag2aa', 'wcag2a'],
        type: 'WCAG'
    },
    wcag22a: {
        value: 'wcag22a',
        name: 'WCAG 2.2 A',
        tags: ['wcag22a', 'wcag21a', 'wcag2a'],
        type: 'WCAG'
    },
    wcag21aaa: {
        value: 'wcag21aaa',
        name: 'WCAG 2.1 AAA',
        tags: ['wcag21aaa', 'wcag21aa', 'wcag21a', 'wcag2aaa', 'wcag2aa', 'wcag2a'],
        type: 'WCAG'
    },
    wcag21aa: {
        value: 'wcag21aa',
        name: 'WCAG 2.1 AA',
        tags: ['wcag21aa', 'wcag21a', 'wcag2aa', 'wcag2a'],
        type: 'WCAG'
    },
    wcag21a: {
        value: 'wcag21a',
        name: 'WCAG 2.1 A',
        tags: ['wcag21a', 'wcag2a'],
        type: 'WCAG'
    },
    wcag2aaa: {
        value: 'wcag2aaa',
        name: 'WCAG 2.0 AAA',
        tags: ['wcag2aaa', 'wcag2aa', 'wcag2a'],
        type: 'WCAG'
    },
    wcag2aa: {
        value: 'wcag2aa',
        name: 'WCAG 2.0 AA',
        tags: ['wcag2aa', 'wcag2a'],
        type: 'WCAG'
    },
    wcag2a: {
        value: 'wcag2a',
        name: 'WCAG 2.0 A',
        tags: ['wcag2a'],
        type: 'WCAG'
    },
    TTv5: {
        value: 'TTv5',
        name: 'Trusted Tester v5',
        tags: ['TTv5'],
        type: 'Trusted Tester'
    },
    'EN-301-549': {
        value: 'EN-301-549',
        name: 'EN 301 549',
        tags: ['EN-301-549'],
        type: 'EN'
    }
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var wcagCheckpointRegex = /^wcag(\d)(\d)(\d{1,3})(\w?)$/;
var wcagStandardRegex = /^wcag(\d{1,2})(a{1,3})$/;
var enAxeCorePattern = /^EN-(\d+)\.(\d+)\.(\d+)\.(\d+)$/i;
var enDequewayPattern = /^en301549-\d-(\d+)\.(\d+)\.(\d+)\.(\w)$/i;
var enStandardPattern = /^EN-301-549$/i;
var ttTagCheckoutPattern = /^TT-(\d+\.\w)$/;
var ttTagStandartPattern = /TTv(\d)/;
var ttAxeCoreCheckpointPattern = /^TT(\d+\.\w)$/;
var section508Pattern = /^section508\.(\d+\.\w)$/;
/*
  Map generated from https://github.com/act-rules/act-tools/blob/main/src/data/sc-urls.json
  Needs to be updated manually when new SCs are added to the ACT Rules
*/
var wcagData = new Map([
    [
        '1.1.1',
        {
            title: 'Non-text Content',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/non-text-content.html'
        }
    ],
    [
        '1.2.1',
        {
            title: 'Audio-only and Video-only (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/audio-only-and-video-only-prerecorded.html'
        }
    ],
    [
        '1.2.2',
        {
            title: 'Captions (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/captions-prerecorded.html'
        }
    ],
    [
        '1.2.3',
        {
            title: 'Audio Description or Media Alternative (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/audio-description-or-media-alternative-prerecorded.html'
        }
    ],
    [
        '1.2.4',
        {
            title: 'Captions (Live)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/captions-live.html'
        }
    ],
    [
        '1.2.5',
        {
            title: 'Audio Description (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/audio-description-prerecorded.html'
        }
    ],
    [
        '1.2.6',
        {
            title: 'Sign Language (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/sign-language-prerecorded.html'
        }
    ],
    [
        '1.2.7',
        {
            title: 'Extended Audio Description (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/extended-audio-description-prerecorded.html'
        }
    ],
    [
        '1.2.8',
        {
            title: 'Media Alternative (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/media-alternative-prerecorded.html'
        }
    ],
    [
        '1.2.9',
        {
            title: 'Audio-only (Live)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/audio-only-live.html'
        }
    ],
    [
        '1.3.1',
        {
            title: 'Info and Relationships',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/info-and-relationships.html'
        }
    ],
    [
        '1.3.2',
        {
            title: 'Meaningful Sequence',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/meaningful-sequence.html'
        }
    ],
    [
        '1.3.3',
        {
            title: 'Sensory Characteristics',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/sensory-characteristics.html'
        }
    ],
    [
        '1.3.4',
        {
            title: 'Orientation',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/orientation.html'
        }
    ],
    [
        '1.3.5',
        {
            title: 'Identify Input Purpose',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/identify-input-purpose.html'
        }
    ],
    [
        '1.3.6',
        {
            title: 'Identify Purpose',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/identify-purpose.html'
        }
    ],
    [
        '1.4.1',
        {
            title: 'Use of Color',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/use-of-color.html'
        }
    ],
    [
        '1.4.2',
        {
            title: 'Audio Control',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/audio-control.html'
        }
    ],
    [
        '1.4.3',
        {
            title: 'Contrast (Minimum)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/contrast-minimum.html'
        }
    ],
    [
        '1.4.4',
        {
            title: 'Resize text',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/resize-text.html'
        }
    ],
    [
        '1.4.5',
        {
            title: 'Images of Text',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/images-of-text.html'
        }
    ],
    [
        '1.4.6',
        {
            title: 'Contrast (Enhanced)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/contrast-enhanced.html'
        }
    ],
    [
        '1.4.7',
        {
            title: 'Low or No Background Audio',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/low-or-no-background-audio.html'
        }
    ],
    [
        '1.4.8',
        {
            title: 'Visual Presentation',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/visual-presentation.html'
        }
    ],
    [
        '1.4.9',
        {
            title: 'Images of Text (No Exception)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/images-of-text-no-exception.html'
        }
    ],
    [
        '1.4.10',
        {
            title: 'Reflow',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/reflow.html'
        }
    ],
    [
        '1.4.11',
        {
            title: 'Non-text Contrast',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/non-text-contrast.html'
        }
    ],
    [
        '1.4.12',
        {
            title: 'Text Spacing',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/text-spacing.html'
        }
    ],
    [
        '1.4.13',
        {
            title: 'Content on Hover or Focus',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/content-on-hover-or-focus.html'
        }
    ],
    [
        '2.1.1',
        {
            title: 'Keyboard',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/keyboard.html'
        }
    ],
    [
        '2.1.2',
        {
            title: 'No Keyboard Trap',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/no-keyboard-trap.html'
        }
    ],
    [
        '2.1.3',
        {
            title: 'Keyboard (No Exception)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/keyboard-no-exception.html'
        }
    ],
    [
        '2.1.4',
        {
            title: 'Character Key Shortcuts',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/character-key-shortcuts.html'
        }
    ],
    [
        '2.2.1',
        {
            title: 'Timing Adjustable',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/timing-adjustable.html'
        }
    ],
    [
        '2.2.2',
        {
            title: 'Pause, Stop, Hide',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/pause-stop-hide.html'
        }
    ],
    [
        '2.2.3',
        {
            title: 'No Timing',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/no-timing.html'
        }
    ],
    [
        '2.2.4',
        {
            title: 'Interruptions',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/interruptions.html'
        }
    ],
    [
        '2.2.5',
        {
            title: 'Re-authenticating',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/re-authenticating.html'
        }
    ],
    [
        '2.2.6',
        {
            title: 'Timeouts',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/timeouts.html'
        }
    ],
    [
        '2.3.1',
        {
            title: 'Three Flashes or Below Threshold',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/three-flashes-or-below-threshold.html'
        }
    ],
    [
        '2.3.2',
        {
            title: 'Three Flashes',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/three-flashes.html'
        }
    ],
    [
        '2.3.3',
        {
            title: 'Animation from Interactions',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/animation-from-interactions.html'
        }
    ],
    [
        '2.4.1',
        {
            title: 'Bypass Blocks',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/bypass-blocks.html'
        }
    ],
    [
        '2.4.2',
        {
            title: 'Page Titled',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/page-titled.html'
        }
    ],
    [
        '2.4.3',
        {
            title: 'Focus Order',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/focus-order.html'
        }
    ],
    [
        '2.4.4',
        {
            title: 'Link Purpose (In Context)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/link-purpose-in-context.html'
        }
    ],
    [
        '2.4.5',
        {
            title: 'Multiple Ways',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/multiple-ways.html'
        }
    ],
    [
        '2.4.6',
        {
            title: 'Headings and Labels',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/headings-and-labels.html'
        }
    ],
    [
        '2.4.7',
        {
            title: 'Focus Visible',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/focus-visible.html'
        }
    ],
    [
        '2.4.8',
        {
            title: 'Location',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/location.html'
        }
    ],
    [
        '2.4.9',
        {
            title: 'Link Purpose (Link Only)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/link-purpose-link-only.html'
        }
    ],
    [
        '2.4.10',
        {
            title: 'Section Headings',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/section-headings.html'
        }
    ],
    [
        '2.4.11',
        {
            title: 'Focus Not Obscured (Minimum)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/focus-not-obscured-minimum.html'
        }
    ],
    [
        '2.4.12',
        {
            title: 'Focus Not Obscured (Enhanced)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/focus-not-obscured-enhanced.html'
        }
    ],
    [
        '2.4.13',
        {
            title: 'Focus Appearance',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/focus-appearance.html'
        }
    ],
    [
        '2.5.1',
        {
            title: 'Pointer Gestures',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/pointer-gestures.html'
        }
    ],
    [
        '2.5.2',
        {
            title: 'Pointer Cancellation',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/pointer-cancellation.html'
        }
    ],
    [
        '2.5.3',
        {
            title: 'Label in Name',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/label-in-name.html'
        }
    ],
    [
        '2.5.4',
        {
            title: 'Motion Actuation',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/motion-actuation.html'
        }
    ],
    [
        '2.5.5',
        {
            title: 'Target Size',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/target-size-enhanced.html'
        }
    ],
    [
        '2.5.6',
        {
            title: 'Concurrent Input Mechanisms',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/concurrent-input-mechanisms.html'
        }
    ],
    [
        '2.5.7',
        {
            title: 'Dragging Movements',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/dragging-movements.html'
        }
    ],
    [
        '2.5.8',
        {
            title: 'Target Size (Minimum)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/target-size-minimum.html'
        }
    ],
    [
        '3.1.1',
        {
            title: 'Language of Page',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/language-of-page.html'
        }
    ],
    [
        '3.1.2',
        {
            title: 'Language of Parts',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/language-of-parts.html'
        }
    ],
    [
        '3.1.3',
        {
            title: 'Unusual Words',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/unusual-words.html'
        }
    ],
    [
        '3.1.4',
        {
            title: 'Abbreviations',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/abbreviations.html'
        }
    ],
    [
        '3.1.5',
        {
            title: 'Reading Level',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/reading-level.html'
        }
    ],
    [
        '3.1.6',
        {
            title: 'Pronunciation',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/pronunciation.html'
        }
    ],
    [
        '3.2.1',
        {
            title: 'On Focus',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/on-focus.html'
        }
    ],
    [
        '3.2.2',
        {
            title: 'On Input',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/on-input.html'
        }
    ],
    [
        '3.2.3',
        {
            title: 'Consistent Navigation',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/consistent-navigation.html'
        }
    ],
    [
        '3.2.4',
        {
            title: 'Consistent Identification',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/consistent-identification.html'
        }
    ],
    [
        '3.2.5',
        {
            title: 'Change on Request',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/change-on-request.html'
        }
    ],
    [
        '3.2.6',
        {
            title: 'Consistent Help',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/consistent-help.html'
        }
    ],
    [
        '3.3.1',
        {
            title: 'Error Identification',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/error-identification.html'
        }
    ],
    [
        '3.3.2',
        {
            title: 'Labels or Instructions',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/labels-or-instructions.html'
        }
    ],
    [
        '3.3.3',
        {
            title: 'Error Suggestion',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/error-suggestion.html'
        }
    ],
    [
        '3.3.4',
        {
            title: 'Error Prevention (Legal, Financial, Data)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/error-prevention-legal-financial-data.html'
        }
    ],
    [
        '3.3.5',
        {
            title: 'Help',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/help.html'
        }
    ],
    [
        '3.3.6',
        {
            title: 'Error Prevention (All)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/error-prevention-all.html'
        }
    ],
    [
        '3.3.7',
        {
            title: 'Redundant Entry',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/redundant-entry.html'
        }
    ],
    [
        '3.3.8',
        {
            title: 'Accessible Authentication (Minimum)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/accessible-authentication-minimum.html'
        }
    ],
    [
        '3.3.9',
        {
            title: 'Accessible Authentication (Enhanced)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/accessible-authentication-enhanced.html'
        }
    ],
    [
        '4.1.1',
        {
            title: 'Parsing',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/parsing.html'
        }
    ],
    [
        '4.1.2',
        {
            title: 'Name, Role, Value',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/name-role-value.html'
        }
    ],
    [
        '4.1.3',
        {
            title: 'Status Messages',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/status-messages.html'
        }
    ]
]);
function getTagInfo(tag) {
    var _a = validateTag(tag), isValid = _a.isValid, checkpoint = _a.checkpoint, checkpointDescription = _a.checkpointDescription, understandingUrl = _a.understandingUrl, standard = _a.standard;
    if (isValid) {
        var tagInfo = {
            standard: standard,
            value: tag
        };
        if (checkpoint) {
            tagInfo.checkpoint = checkpoint;
        }
        if (checkpointDescription) {
            tagInfo.checkpointDescription = checkpointDescription; // Set the description if available
        }
        if (understandingUrl) {
            tagInfo.understandingUrl = understandingUrl; // Set the URL if available
        }
        return tagInfo;
    }
}
function validateTag(tag) {
    if (tag.startsWith('wcag')) {
        var match = wcagCheckpointRegex.exec(tag);
        if (match) {
            var _a = __read(match, 5), major = _a[1], minor = _a[2], checkpoint = _a[3], suffix = _a[4];
            var formattedTag = "".concat(major, ".").concat(minor, ".").concat(checkpoint);
            var wcagInfo = wcagData.get(formattedTag);
            if (wcagInfo) {
                return {
                    isValid: true,
                    checkpoint: "".concat(formattedTag).concat(suffix),
                    checkpointDescription: wcagInfo.title,
                    understandingUrl: wcagInfo.url,
                    standard: 'WCAG'
                };
            }
        }
        else if (wcagStandardRegex.test(tag)) {
            return {
                isValid: true,
                standard: 'WCAG'
            };
        }
        return { isValid: false };
    }
    if (/^en/i.test(tag)) {
        if (enAxeCorePattern.test(tag)) {
            var match = enAxeCorePattern.exec(tag);
            if (match) {
                var _b = __read(match, 5), type = _b[1], major = _b[2], minor = _b[3], checkpoint = _b[4];
                var formattedTag = "".concat(type, ".").concat(major, ".").concat(minor, ".").concat(checkpoint);
                var wcagInfo = wcagData.get("".concat(major, ".").concat(minor, ".").concat(checkpoint));
                if (wcagInfo) {
                    return {
                        isValid: true,
                        checkpoint: formattedTag,
                        checkpointDescription: wcagInfo.title,
                        standard: 'EN'
                    };
                }
                return {
                    isValid: true,
                    checkpoint: formattedTag,
                    standard: 'EN'
                };
            }
        }
        else if (enDequewayPattern.test(tag)) {
            var match = enDequewayPattern.exec(tag);
            if (match) {
                var _c = __read(match, 4), fullMatch = _c[0], major = _c[1], minor = _c[2], checkpoint = _c[3];
                var type = fullMatch.split('-')[1];
                var formattedTag = "".concat(type, ".").concat(major, ".").concat(minor, ".").concat(checkpoint);
                var wcagInfo = wcagData.get("".concat(major, ".").concat(minor, ".").concat(checkpoint));
                if (wcagInfo) {
                    return {
                        isValid: true,
                        checkpoint: formattedTag,
                        checkpointDescription: wcagInfo.title,
                        standard: 'EN'
                    };
                }
                return {
                    isValid: true,
                    checkpoint: formattedTag,
                    standard: 'EN'
                };
            }
        }
        else if (enStandardPattern.test(tag)) {
            return {
                isValid: true,
                standard: 'EN'
            };
        }
        return { isValid: false };
    }
    if (tag.startsWith('TT')) {
        if (ttTagCheckoutPattern.test(tag)) {
            var match = ttTagCheckoutPattern.exec(tag);
            if (match) {
                return {
                    isValid: true,
                    checkpoint: match[1],
                    standard: 'Trusted Tester'
                };
            }
        }
        else if (ttTagStandartPattern.test(tag)) {
            return {
                isValid: true,
                standard: 'Trusted Tester'
            };
        }
        else if (ttAxeCoreCheckpointPattern.test(tag)) {
            var match = ttAxeCoreCheckpointPattern.exec(tag);
            if (match) {
                return {
                    isValid: true,
                    checkpoint: match[1],
                    standard: 'Trusted Tester'
                };
            }
        }
    }
    if (tag.startsWith('section508')) {
        var match = section508Pattern.exec(tag);
        if (match) {
            return {
                isValid: true,
                checkpoint: match[1],
                standard: 'Section 508'
            };
        }
    }
    return { isValid: false };
}

var validate = function (value) {
    return Object.keys(rulesets).indexOf(value) !== -1;
};

exports.default = rulesets;
exports.getTagInfo = getTagInfo;
exports.rulesets = rulesets;
exports.validate = validate;
